import { useContext, useState } from 'react'
import { AppContext } from '../../contextApi/ContextApi';
import { media } from '../../dataSets/media';

export default function Social({isDashboard}) {
  const { currentWebsite, accent_color, primary_color, moveToEditNavBtns } = useContext(AppContext);
  const [social] = useState(currentWebsite?.settings?.social);
  const [isHover, setIsHover] = useState(false);

  return (
    <div id='navbarUpperDiv_left'>
        {
        // if none of the social buttons includes and only if at dashboard status
        !social?.whatsapp?.include&&!social?.instagram?.include&&!social?.facebook?.include&&isDashboard ? 
          <h3 style={{color:isHover ? primary_color : accent_color}} onMouseEnter={()=>{setIsHover(true)}} onMouseLeave={()=>{setIsHover(false)}} onClick={moveToEditNavBtns}>הוסף רשתות חברתיות</h3> : 
          // => at any other condition when surely isn't dashboard and any one of the social buttons are includes
          <div id='navbarUpperDiv_left_sub'>
            {social?.whatsapp?.include && <a style={{backgroundColor:"white"}} href={`${social?.whatsapp?.url}`} target='_blank' rel='noreferrer' className={isDashboard ? "navbarSocialBtns_dashboard" : 'navbarSocialBtns'}><img id={isDashboard ? "whatsapp_dashboard" : 'whatsapp'} src={media?.whatsappLogo} alt="whatsapp_button" /></a>}
            {social?.instagram?.include && <a style={{backgroundColor:"white"}} href={`${social?.instagram?.url}`} target='_blank' rel='noreferrer' className={isDashboard ? "navbarSocialBtns_dashboard" : 'navbarSocialBtns'}><img id={isDashboard ? "instagram_dashboard" : 'instagram'} src={media?.instagramLogo} alt="instagram_button" /></a>}
            {social?.facebook?.include && <a style={{backgroundColor:"white"}} href={`${social?.facebook?.url}`} target='_blank' rel='noreferrer' className={isDashboard ? "navbarSocialBtns_dashboard" : 'navbarSocialBtns'}><img id={isDashboard ? "facebook_dashboard" : 'facebook'} src={media?.facebookLogo} alt="facebook_button" /></a>}
          </div>
        }
    </div>
  )
}
